export default function (state = {}, action) {
	switch (action.type) {

	case 'FETCH_AUTHOR_REPOS_SUCCESS':				
		const response=action.response
			 return {...state,
			 [`${action.authorId}`]:response
			 }
	
	case 'LOGOUT':
		return {}
	
	default:
		return state
	
	}
}
